import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-white py-4">
      <div className="container text-center">
        <p className="mb-2">© 2025 Kocur.ai All rights reserved.</p>
        <Link to="/terms" className="text-white text-decoration-underline me-3">Podmienky používania</Link>
        <Link to="/privacy" className="text-white text-decoration-underline">Zásady Ochrany Osobných Údajov</Link>
      </div>
    </footer>
  );
};

export default Footer;
